const font = {
  family: "'Inter', sans-serif",
};

const color = {
  accent: "#9FA3EF",
  background: {
    primary: "#1E1D2A",
    secondary: "#222432",
    tertiary: "#2B2C3D",
    light: "#38394F",
  },
  text: {
    primary: "#F1F1F2",
    secondary: "#090A17",
    caption: "#7F7F86",
    destructive: "#FF3C38",
  },
};

const desktop = {
  font: {
    ...font,
    size: {
      primary: "24px",
      secondary: "18px",
      tertiary: "16px",
      disclaimer: "16px",
      small: "14px",
    },
  },
  color: color,
  iconSize: {
    large: "58px",
    medium: "48px",
  },
  coloredButtonHeight: {
    primary: "58px",
  },
  padding: {
    content: "48px",
  },
};

const mobile = {
  font: {
    ...font,
    size: {
      primary: "16px",
      secondary: "16px",
      tertiary: "12px",
      disclaimer: "14px",
      small: "14px",
    },
  },
  color: color,
  iconSize: {
    large: "40px",
    medium: "24px",
  },
  coloredButtonHeight: {
    primary: "46px",
  },
  padding: {
    content: "24px",
  },
};

const theme = {
  mobile,
  desktop,
};

export default theme;
